




















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class BackToTopButton extends Vue {
  showButton = false;

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  handleScroll() {
    this.showButton = window.scrollY > 300;
  }

  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
